// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*[hidden] {
  display: none;
}

.load-latest-button {
  margin-right: 0.5rem;
}

.unused-acc-window {
  position: fixed;
  right: 100%;
  top: 0%;
  z-index: 99;
}

.icon_close {
  color: whitesmoke;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  background: rgba(0, 0, 0, 0.6);
}`, "",{"version":3,"sources":["webpack://./src/app/components/model-structure/balance-sheet/balance-sheet.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;EACA,OAAA;EACA,WAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,8BAAA;AAAF","sourcesContent":["*[hidden] {\r\n  display: none;\r\n}\r\n\r\n.load-latest-button {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.unused-acc-window {\r\n  position: fixed;\r\n  right: 100%;\r\n  top: 0%;\r\n  z-index: 99;\r\n}\r\n\r\n.icon_close {\r\n  color: whitesmoke;\r\n}\r\n\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 50;\r\n\r\n  background: rgba(0, 0, 0, 0.6);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
